let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jPMEb")).then(() => parcelRequire('7NiVE'));